import trackDonation from '../containers/Donation/tracking';
import trackPoll from '../containers/Poll/tracking';
import trackSentimentPoll from '../containers/SentimentPoll/tracking';
import trackQuiz from '../containers/Quiz/tracking';
import trackWidget from '../containers/Widget/tracking';
import trackCall from '../containers/Call/tracking';
import trackEmail from '../containers/Email/tracking';
import trackLink from '../containers/Link/tracking';
import trackTweet from '../containers/Tweet/tracking';
import trackVideo from '../containers/Video/tracking';
import trackVolunteer from '../containers/Volunteer/tracking';
import trackLocalRep from '../containers/LocalRep/tracking';
import trackVoteRegistration from '../containers/VoteRegistration/tracking';
import trackElectionReminder from '../containers/ElectionReminder/tracking';
import trackCheckRegistration from '../containers/CheckRegistration/tracking';
import trackFindPollingStation from '../containers/FindPollingStation/tracking';
import { loadGoogleAnalytics } from '../utils/tracking/googleAnalytics';
import { loadGoogleAnalyticsSalon } from '../utils/tracking/salonTracking';
import config from '../config';

export const trackingMiddleware = store => next => action => {
    let result = next(action);
    trackDonation(action.type, store.getState());
    trackPoll(action.type, store.getState());
    trackSentimentPoll(action.type, store.getState());
    trackQuiz(action.type, store.getState());
    trackCall(action.type, store.getState());
    trackEmail(action.type, store.getState());
    trackTweet(action.type, store.getState());
    trackVideo(action.type, store.getState());
    trackLink(action.type, store.getState());
    trackWidget(action.type, store.getState());
    trackLocalRep(action.type, store.getState());
    trackVoteRegistration(action.type, store.getState());
    trackElectionReminder(action.type, store.getState());
    trackCheckRegistration(action.type, store.getState());
    trackFindPollingStation(action.type, store.getState());
    trackVolunteer(action.type, store.getState());
    return result;
};

export const initTrackingMiddleware = data => {
    if (data == null) return;
    loadGoogleAnalytics({
        googleAnalyticsUserId: config.GOOGLE_ANALYTICS_USER_ID,
        googleAnalyticsEventUserId: config.GOOGLE_ANALYTICS_EVENTS_USER_ID,
        articleUrl: data.articleUrl,
        experimentId: data.experimentId,
        variationId: data.variationId
    });
    loadGoogleAnalyticsSalon(data.articleUrl);
};



// WEBPACK FOOTER //
// ./src/middleware/trackingMiddleware.js